import React from "react";
import {
  Intent,
  Button,
  InputGroup,
  Classes,
  Dialog,
  FormGroup
} from "@blueprintjs/core";
import { useProductsList } from "../ShippingProfileList/hooks";
import styles from "../ShippingSettings.module.scss";
import { SelectList } from "../../../../molecules/SelectList";

export function AddProductButton({
  isModalOpen,
  setIsModalOpen,
  searchText,
  setSearchText,
  productIds,
  setProductIds,
  editShippingProfile,
  onCloseDialog,
  isSaving,
  profileId
}) {
  const { productList, loading } = useProductsList(
    searchText,
    isModalOpen,
    profileId
  );

  return (
    <>
      <Dialog
        icon="tag"
        onClose={onCloseDialog}
        title="Products"
        isOpen={isModalOpen}
        className={styles.simpleDialog}
        canOutsideClickClose={!isSaving}
        canEscapeKeyClose={!isSaving}
      >
        <div className={Classes.DIALOG_BODY}>
          <FormGroup label="Products" labelFor="productSearch">
            <InputGroup
              leftIcon="search"
              type="search"
              id="productSearch"
              value={searchText}
              onChange={setSearchText}
              placeholder="Search products"
            />
          </FormGroup>
          <SelectList
            data={productList}
            value={productIds}
            onChange={setProductIds}
            loading={loading}
          />
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              text="Cancel"
              type="button"
              minimal="true"
              disabled={isSaving}
              onClick={onCloseDialog}
              intent={Intent.NONE}
            />
            <Button
              text="Save"
              loading={isSaving}
              onClick={editShippingProfile}
              intent={Intent.PRIMARY}
            />
          </div>
        </div>
      </Dialog>
      <Button
        text="Add Products"
        intent={Intent.PRIMARY}
        minimal={true}
        onClick={() => setIsModalOpen(true)}
      />
    </>
  );
}
